import { COMPANY, CONTACTS, LEGAL_NAME, SITE_NAME, SITE_ORIGIN } from './constants.js'
import { payoutVideo } from './media.js'

export function canonicalFor(path) {
  return path === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`
}

export function breadcrumbItems(page) {
  if (page.path === '/') return []
  const parents = {
    '/instructions/yandex-pro': ['/instructions', 'Инструкции'],
  }
  const items = [{ name: 'Главная', path: '/' }]
  const parent = parents[page.path]
  if (parent) items.push({ name: parent[1], path: parent[0] })
  items.push({ name: page.navLabel, path: page.path })
  return items
}

export function buildSchemas(page) {
  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_ORIGIN}/#organization`,
    name: LEGAL_NAME,
    alternateName: SITE_NAME,
    url: `${SITE_ORIGIN}/`,
    telephone: CONTACTS.phoneDisplay,
    identifier: [
      { '@type': 'PropertyValue', propertyID: 'ИНН', value: COMPANY.inn },
      { '@type': 'PropertyValue', propertyID: 'ОГРН', value: COMPANY.ogrn },
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'ул. Ивана Черных, д. 20, литера А, помещ. 101',
      addressLocality: 'Санкт-Петербург',
      postalCode: '198095',
      addressCountry: 'RU',
    },
    sameAs: [CONTACTS.vk, CONTACTS.youtube, CONTACTS.telegramChannel],
  }

  const webPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonicalFor(page.path)}#webpage`,
    url: canonicalFor(page.path),
    name: page.title,
    description: page.description,
    inLanguage: page.path === '/uz' ? 'uz-Latn' : 'ru-RU',
    isPartOf: {
      '@type': 'WebSite',
      '@id': `${SITE_ORIGIN}/#website`,
      url: `${SITE_ORIGIN}/`,
      name: SITE_NAME,
      publisher: { '@id': `${SITE_ORIGIN}/#organization` },
    },
  }

  const schemas = [organization, webPage]
  const crumbs = breadcrumbItems(page)
  if (crumbs.length) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: canonicalFor(item.path),
      })),
    })
  }

  if (page.faq?.length) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: page.faq.map(([question, answer]) => ({
        '@type': 'Question',
        name: question,
        acceptedAnswer: { '@type': 'Answer', text: answer },
      })),
    })
  }
  if (page.path === '/instructions/yandex-pro') {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: 'Как вывести деньги из Яндекс Про — инструкция Лены',
      description: 'Пошаговая видеоинструкция по выводу денег из Яндекс Про для водителей и курьеров.',
      thumbnailUrl: [payoutVideo.poster],
      contentUrl: payoutVideo.src,
      uploadDate: payoutVideo.uploadDate,
      duration: payoutVideo.duration,
      inLanguage: 'ru-RU',
      publisher: { '@id': `${SITE_ORIGIN}/#organization` },
      isPartOf: { '@id': `${canonicalFor(page.path)}#webpage` },
    })
  }
  return schemas
}

export function updateDocumentMeta(page) {
  if (typeof document === 'undefined') return
  document.title = page.title
  document.querySelector('meta[name="description"]')?.setAttribute('content', page.description)
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonicalFor(page.path))
  document.documentElement.lang = page.path === '/uz' ? 'uz' : 'ru'
  let script = document.querySelector('#runtime-page-schema')
  if (!script) {
    script = document.createElement('script')
    script.id = 'runtime-page-schema'
    script.type = 'application/ld+json'
    document.head.append(script)
  }
  script.textContent = JSON.stringify(buildSchemas(page))
}
